module.exports = __webpack_public_path__ + "img/icon-49.b5833d29.svg";